import vueAppInitiator from '../../modules/vue-app-initiator';
import vueUIInitiator from '../../modules/vue-ui-initiator';
import FormGreenGostContacts from '../../vue-components/FormGreenGostContacts';
import CircleChart from '../../vue-components/CircleChart';
import RoadmapSlider from '../../vue-components/RoadmapSlider';

const vueApps = [
    {
        el: '#green-gost-form-block',
        components: {
            FormGreenGostContacts,
        },
    },
];

vueUIInitiator('js--circle-chart-init', CircleChart, 'circle-chart');
vueUIInitiator('js--roadmap-slider-init', RoadmapSlider, 'roadmap-slider');

vueAppInitiator(vueApps);
